import { TreeItem } from "@abaco/map-web-module/src/modules/map-web-module/components/common/tree/TreeItem";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

export default class LayerManagementVuexModule extends AbacoVuexModule {
    //eslint-disable-next-line
    @State() farmLayers!: TreeItem[] | null;
    @State() createModalOpen!: boolean;
}
